export const CODELIST_KEY = 'codelist'

export const codelistQueryKeys = {
  all: [CODELIST_KEY] as const,
  group: (group: string) => [...codelistQueryKeys.all, 'group', group] as const,
  search: (codeLabel: string, pageNumber: number, country: string | null) => [...codelistQueryKeys.all, 'search', pageNumber, codeLabel, country] as const,
}
